import { jsx as n } from "react/jsx-runtime";
import { enUS as T } from "../../node_modules/date-fns/locale/en-US.mjs";
import { useState as l, useEffect as $ } from "react";
import { DatePicker as j } from "../../node_modules/react-datepicker/dist/index.es.mjs";
import { ButtonInput as C } from "./components/button-Input.mjs";
import { DatePickerHeader as E } from "./components/date-picker-header.mjs";
import { DateModeEnum as f } from "./enum/date-mode-enum.mjs";
import { useDateFnsLocale as F } from "./hooks/use-date-fns-locale.mjs";
import { setDateTill as H } from "./utills/set-date-till.mjs";
import { flip as A, shift as U } from "../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs";
import { setDateWithTimezone as u, toISOStringWithoutTimezone as W } from "../../utils/date-time-format.mjs";
import { getDate as q } from "../../utils/get-dates.mjs";
const et = ({
  mode: D = f.DateSince,
  value: a,
  onChange: s,
  description: b,
  error: m,
  label: x,
  required: S,
  placeholder: g,
  maxDate: y,
  minDate: h,
  wrapperButtonInputClassName: M,
  disabled: c,
  timezone: r,
  intlLocale: d,
  createdAt: p,
  labelClassName: w
}) => {
  const [o, i] = l(
    a && u(a, r) || null
  ), [k, I] = l(), [L, P] = l(T), B = p && r ? q(p, r) : null;
  return F(d, P), $(() => {
    if (!r) return;
    const t = a ? u(a, r) : null;
    (!o || (t == null ? void 0 : t.toISOString()) !== o.toISOString()) && i(t);
  }, [a, r, o]), /* @__PURE__ */ n("div", { children: /* @__PURE__ */ n(
    j,
    {
      selected: o,
      dateFormat: "MMMM d, yyyy",
      onChange: (t) => {
        t && ((o ? t.toDateString() === o.toDateString() : !1) ? (i(null), s(null)) : (i(t), D === f.DateTill && H(t), s(W(t))));
      },
      onChangeRaw: (t) => {
        const e = t == null ? void 0 : t.target;
        k === (e == null ? void 0 : e.ariaLabel) ? (i(null), s(null)) : I(e == null ? void 0 : e.ariaLabel);
      },
      locale: L,
      minDate: h || B || void 0,
      maxDate: y || void 0,
      nextMonthButtonLabel: ">",
      previousMonthButtonLabel: "<",
      popperModifiers: [A(), U({ padding: 5, crossAxis: !0 })],
      showPopperArrow: !1,
      customInput: /* @__PURE__ */ n(
        C,
        {
          description: b,
          buttonInputClassName: `flex group justify-between min-w-[200px] w-full py-2.5 px-4 text-sm font-medium text-text-primary border ${c ? "bg-background-tertiary/40" : "bg-background-secondary focus:border-brand-primary"} ${m ? "border-danger" : "border-text-secondary/30"} rounded-lg bg-background-secondary focus:outline-hidden focus:border-brand-primary main-transition-colors`,
          error: m,
          label: x,
          required: S,
          wrapperButtonInputClassName: M,
          labelClassName: w,
          children: (t) => /* @__PURE__ */ n("span", { className: "text-start", children: t || /* @__PURE__ */ n("span", { className: "text-text-tertiary/70", children: g }) })
        }
      ),
      renderCustomHeader: ({
        date: t,
        decreaseMonth: e,
        increaseMonth: N,
        prevMonthButtonDisabled: O,
        nextMonthButtonDisabled: R
      }) => /* @__PURE__ */ n(
        E,
        {
          date: t,
          decreaseMonth: e,
          increaseMonth: N,
          prevMonthButtonDisabled: O,
          nextMonthButtonDisabled: R,
          intlLocale: d
        }
      ),
      disabled: c
    }
  ) });
};
export {
  et as DatePicker
};
